export const NODE_DETAILS_TEST_ID = {
  panel: 'tree-node-details-panel',
  closeButton: 'tree-node-details-close-button',
  loading: 'tree-node-details-loading',
  readOnlyIcon: 'tree-node-details-read-only-icon',
  property: (index: number) => `tree-node-details-property-${index}`
};
